import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Table } from '../../../../components/Sessions/Table';
import { useLazyGetUpcomingSessionsQuery } from '../../../../../store/services/student/SessionService';
import Pagination from '../../../../components/Dashboard/Pagination';
import { getColumns } from '../../../../components/Dashboard/Columns';

export const TutorSessionsUpcoming = () => {
  const navigate = useNavigate();
  const [sessionsData, setSessionsData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [pageSize] = useState(10);

  const [triggerGetUpcomingSessions, { data, isLoading, error }] = useLazyGetUpcomingSessionsQuery();

  const fetchData = () => {
    triggerGetUpcomingSessions({ pageNumber: currentPage, pageSize, search: searchTerm });
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, searchTerm]);

  useEffect(() => {
    if (data?.data) {
      setSessionsData(data.data.items || []);
      setTotalCount(data.data.totalCount || 0);
    }
  }, [data]);

  if (isLoading) return <div className="text-center py-5"><div className="spinner-border" role="status"></div></div>;
  if (error) return <div className="alert alert-danger">Error loading upcoming sessions.</div>;

  return (
    <div className="bg-white">
      <div className="page-title flex-wrap mb-0">
        <div className="input-group search-area mb-md-0 ml-3">
          <input
            type="text"
            className="form-control ps-4"
            placeholder="Search upcoming sessions..."
            value={searchTerm}
            onChange={(e) => {
              setCurrentPage(1);
              setSearchTerm(e.target.value);
            }}
          />
        </div>
      </div>

      <Table
        data={sessionsData}
        columns={getColumns(sessionsData, true, true, false)}
        pageSize={pageSize}
        filterConfig={[]}
        buttonConfig={[]}
        searchableColumns={[]}
        onRowClick={(item) => navigate(`/sessions/sessionDetails/${item.sessionId}`)}
      />

      <Pagination currentPage={currentPage} totalCount={totalCount}
                pageSize={pageSize} onPageChange={setCurrentPage}/>
    </div>
  );
};